<template>
  <div class="freetime">
    <div class="topclass">
      <h4>Open PPT Slot<span>*</span></h4>
      <p style="line-height: 30px">Set your weekly available time slots. Please click save after modification.</p>
      <p v-html="info" style="line-height: 30px"></p>
    </div>
    <div class="func_box">
      <div class="list_time">
        <div class="item">
          <p class="Week">Select Date</p>
          <p class="Time">Start Time</p>
          <p class="End">End Time</p>
          <p class="End">Beijing Time</p>
<!--          <p class="Del"><img src="../../assets/del.png" alt=""></p>-->
        </div>
        <div class="item" v-for="time in timeList" :key="time.id">
          <p class="Week">
            <el-select v-model="time.weekday" collapse-tags :disabled="!time.isEdit">
              <el-option v-for="item in weeklist"
                       :key="item"
                       :label="item"
                       :value="item">{{item}}</el-option>
            </el-select>
          </p>
          <p class="Time">
            <el-time-select
              placeholder="Start Time"
              v-model="time.start_at"
              :disabled="!time.isEdit"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '24:00'
              }"

            >
            </el-time-select>
          </p>
          <p class="End">
            <el-time-select
              placeholder="End Time"
              :disabled="!time.isEdit"
              v-model="time.end_at"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '24:00',
                minTime: time.start_at
              }" >
            </el-time-select>
          </p>
          <p>
            <el-time-select
              :disabled="true"
              v-if="!time.isEdit"
              v-model="time.bj_time"
              style="width: 270px;"
              >
            </el-time-select>
          </p>
<!--          <p @click="delTime(time)" class="Del"><img src="../../assets/del.png" alt="" ></p>-->
        </div>
      </div>

      <div class="add_time" @click="addTime">
        <img src="../../assets/add.png" alt="">
        <span>New Time Slot</span>
      </div>
      <div class="btn_time">
<!--        <el-button>Cancel</el-button>-->
        <el-button @click="submit">Save Changes</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FreeTime",
  data(){
    return{
      timeList: [{}],
      weeklist: [
        {
          weekday: '1',
          label: 'Sunday'
        },
        {
          weekday: '2',
          label: 'Monday'
        },
        {
          weekday: '3',
          label: 'Tuesday'
        },
        {
          weekday: '4',
          label: 'Wednesday'
        },
        {
          weekday: '5',
          label: 'Thursday'
        },
        {
          weekday: '6',
          label: 'Firday'
        },
        {
          weekday: '7',
          label: 'Saturday'
        }
      ],
      info:null
    }
  },
  created () {
    this.getTimeList()
    this.weeklist = this.getNextMonthDates()
  },
  methods: {
    getNextMonthDates() {
      const dates = [];
      const startDate = new Date(); // 今天
      const endDate = new Date();

      // 设置结束日期为1个月后的同一天（然后减去1天）
      endDate.setMonth(endDate.getMonth() + 1);
      endDate.setDate(endDate.getDate() - 1); // 减去1天得到一个月后的前一天

      // 复制startDate用于循环，避免修改原始对象
      const currentDate = new Date(startDate);

      while (currentDate <= endDate) {
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');

        dates.push(`${year}-${month}-${day}`);
        currentDate.setDate(currentDate.getDate() + 1);
      }

      return dates;
    },
    getTimeList () {
      this.$http.get('/tutor/api/getFreeTime').then((res) => {
        this.timeList = res.data.data.teacher_setting
        this.info = res.data.data.info
      })
    },
    delTime (timeObj) {
      console.log(this.timeList, '---q')
      this.timeList = this.timeList.filter(item => item != timeObj)
      console.log(this.timeList, '---h')
    },
    addTime () {
      this.timeList.push({isEdit:true})
    },
    submit () {
      let that = this
      function convertToFormData(settings) {
        const formData = new FormData();

        settings.forEach((setting, index) => {
          if(setting.weekday && setting.start_at && setting.end_at){
            const baseKey = `teacher_setting[${index + 1}]`;
            formData.append(`${baseKey}[weekday]`, setting.weekday);
            formData.append(`${baseKey}[start_at]`, setting.start_at);
            formData.append(`${baseKey}[end_at]`, setting.end_at);
          }
        });

        return formData;
      }

      this.$http.post('/tutor/api/saveFreeTime', convertToFormData(this.timeList), {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((res) => {
        console.log(res, '---------fasdasd')
        if(res.data.code == 200){
          this.$message.success(res.data.msg)
          this.getTimeList()
        }else {
          this.$message.error(res.data.msg)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.topclass{
  font-family: Arial;
  font-size: 20px;
  font-weight: normal;
  line-height: 28px;
  letter-spacing: 0px;
  margin-top: 47.5px;
  color: #111827;
  margin-bottom: 25px;
  span{
    color: red;
    display: inline-block;
    margin-left: 10.75px;
  }
  p{
    margin-top: 4px;
    font-family: Alibaba PuHuiTi 3.0;
    font-size: 14px;
    font-weight: 250;
    line-height: 20px;
    letter-spacing: 0px;

    font-feature-settings: "kern" on;
    color: #6B7280;
  }
}
.func_box{
  .list_time{
    .item{
      display: flex;
      flex-direction: row;
      margin-top: 15px;
      .Week{
        width: 234.5px;
      }
      .Time{
        width: 234.5px;
      }
      .End{
        width: 234.5px;
      }
      .Del{
        width: 110px;
        border-radius: 4px;
        border: 1px solid #FF6C62;
        height: 38px;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
      }
      .Del:hover{
        background-color: rgba(255, 108, 98, 0.1);
      }
    }
  }
  .add_time{
    color: #FF904D;
    margin-top: 25px;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    margin-bottom: 40px;
    span{
      display: inline-block;
      margin-left: 5px;
    }
  }
  .btn_time{
    text-align: right;
    margin-right: 200px;
    .el-button{
      background-color: #ff904D;
      color: #fff;
    }
    .el-button:hover{
      color: #ff904D;
      background-color: rgba(255, 144, 77, 0.1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/FreeTimes.vue